import { createSlice } from "@reduxjs/toolkit";

const mallsSlice = createSlice({
  name: "malls",
  initialState: {
    malls: [],
    selectedMall: null,
    loading: false,
    error: null,
    pagination: {
      page: 1,
      totalPages: 1,
      total: 0,
    },
  },
  reducers: {
    setMalls: (state, action) => {
      state.malls = action.payload;
    },
    addMall: (state, action) => {
      state.malls.unshift(action.payload);
    },
    updateMall: (state, action) => {
      const index = state.malls.findIndex((m) => m._id === action.payload._id);
      if (index !== -1) {
        state.malls[index] = action.payload;
      }
    },
    deleteMall: (state, action) => {
      state.malls = state.malls.filter((m) => m._id !== action.payload);
    },
    setSelectedMall: (state, action) => {
      state.selectedMall = action.payload;
    },
    setMallsLoading: (state, action) => {
      state.loading = action.payload;
    },
    setMallsError: (state, action) => {
      state.error = action.payload;
    },
    setMallsPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    clearMallsState: (state) => {
      state.malls = [];
      state.selectedMall = null;
      state.loading = false;
      state.error = null;
      state.pagination = { page: 1, totalPages: 1, total: 0 };
    },
  },
});

export const {
  setMalls,
  addMall,
  updateMall,
  deleteMall,
  setSelectedMall,
  setMallsLoading,
  setMallsError,
  setMallsPagination,
  clearMallsState,
} = mallsSlice.actions;

export default mallsSlice.reducer;
